import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCommunicationQuiz, fetchResponsableQuiz} from 'app/actions/CommunicationQuizActions';
import {
    getCommunicationQuiz,
    getIsLoadingCommunicationProgramSummary,
    getResponsableQuiz,
    getIsLoadingResponsableQuiz
} from '../../reducers/index';
import isEmpty from 'app/utils/IsEmpty';


export default function CommunicationQuizContainer(props) {

    const communicationQuiz = useSelector(getCommunicationQuiz);
    const responsableQuiz = useSelector(getResponsableQuiz);
    const isLoading = useSelector(getIsLoadingCommunicationProgramSummary);

    const dispatch = useDispatch();
    useEffect(() => {
        if (isEmpty(communicationQuiz) && !props.isWorkCycle){
            fetchQuiz(props.data.idCommunication);
        } 
        if (isEmpty(responsableQuiz) && props.isWorkCycle && props.isChildrenVisible) {
            fetchResponsableQuizData(props.idCommunication);
        } 

    }, []);
   
    const fetchQuiz = (id) => dispatch(fetchCommunicationQuiz(id));
    const fetchResponsableQuizData = (id) => dispatch(fetchResponsableQuiz(id));
    return (props.children({ isLoading, communicationQuiz, responsableQuiz, getIsLoadingResponsableQuiz }));
}
